import createAsyncActionType from "../../../utilities/createAsyncActionType";

export const GET_ASYNC_JOBS = createAsyncActionType("GET_ASYNC_JOBS");

export const GET_ASYNC_JOBS_COUNT = createAsyncActionType(
  "GET_ASYNC_JOBS_COUNT"
);

export const DOWNLOAD_ASYNC_JOB_FILE = createAsyncActionType(
  "DOWNLOAD_ASYNC_JOB_FILE"
);

export const SET_ASYNC_JOBS_SEARCH_FILTERS = "SET_ASYNC_JOBS_SEARCH_FILTERS";

export const SET_ASYNC_JOBS_CURRENT_PAGE = "SET_ASYNC_JOBS_CURRENT_PAGE";

export const CLEAR_DOWNLOADED_ASYNC_FILE = "CLEAR_DOWNLOADED_ASYNC_FILE";

export const CREATE_ASYNC_JOB = createAsyncActionType("CREATE_ASYNC_JOB");

export const DELETE_ASYNC_JOB = createAsyncActionType("DELETE_ASYNC_JOB");

export const SET_ASYNC_JOBS_ITEMS_PER_PAGE = "SET_ASYNC_JOBS_ITEMS_PER_PAGE";

export const SET_NO_ENTRIES_MESSAGE_ASYNC_JOBS =
  "SET_NO_ENTRIES_MESSAGE_ASYNC_JOBS";



// WEBPACK FOOTER //
// ./src/features/organization/types/getAsyncJobs.js